module.exports = __webpack_public_path__ + "static/media/desktop_mac.915308b3.svg";